import React from 'react';
import { useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import {
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
  StyledTypography,
  StyledDialogCloseButton,
  StyledList,
} from './styles.js';

const ConteudoParaPostModal = ({ open, onClose }) => {
  return (
    <StyledDialog open={open} onClose={onClose} fullWidth>
      <StyledDialogContent>
        <StyledDialogCloseButton onClick={onClose}>
          <CloseIcon />
        </StyledDialogCloseButton>

        <StyledDialogTitle>
          FIQUE AINDA MAIS PERTO DAS NOSSAS MARCAS!
        </StyledDialogTitle>

        <StyledTypography>
          Atualizamos nosso menu lateral!
        </StyledTypography>

        <StyledList>
          <li>Conteúdos exclusivos das marcas</li>
          <li>Links diretos para os grupos oficiais do Programa Afiliados no WhatsApp</li>
        </StyledList>

        <StyledTypography>
          Por lá, você recebe lançamentos, treinamentos, dicas de vendas, materiais de apoio e conteúdos pensados para te ajudar a alavancar suas vendas no Programa Afiliados — tudo separado por marca.
        </StyledTypography>

        <StyledTypography style={{ marginBottom: 0 }}>
          Acesse agora e fique por dentro!
        </StyledTypography>

      </StyledDialogContent>
    </StyledDialog>
  );
};

export default ConteudoParaPostModal;
